import styled from 'styled-components';
import Head from 'next/head';
import ShopGroup from './ShopGroup';
import ShopNavigationLetters from './ShopNavigationLetter';

const DividerDiv = styled.div`
  width: 100%;
  border-bottom: ${p => `1px solid ${p.theme.c.border.primary}`};
`;

const ShopsDirectoryContent = (props) => {
  const {
    userData,
    pageStateModifiers,
    shopOrder = {},
    locale,
    isMobile,
    globalPageConfig = {},
    globalShopConfig = {},
  } = props;

  const order = shopOrder.order || [];

  const CreateShopGroup = (bool) => {
    return order.map((letter, index, self) => {
      return (
        <ShopGroup
          key={`shop-group-${letter}`}
          letter={letter}
          shops={shopOrder[letter]}
          locale={locale}
          index={index}
          length={self.length}
          pageStateModifiers={pageStateModifiers}
          userData={userData}
          isMobile={bool} />
      );
    });
  };

  const {
    metaDescription = '',
    directoryPageTitle = '',
  } = globalShopConfig;

  const metaDescriptionToUse = metaDescription || (globalPageConfig && globalPageConfig.defaultMetaDescription);
  const pageTitleBase = globalPageConfig && globalPageConfig.pageTitleBase ? globalPageConfig.pageTitleBase : '';
  const pageTitleToUse = `${directoryPageTitle} ${pageTitleBase}`;

  return (
    <div>
      <Head>
        <title>{pageTitleToUse}</title>
        <meta name="description" content={metaDescriptionToUse} />
      </Head>

      <ShopNavigationLetters shopOrder={shopOrder} isMobile={isMobile} />
      <DividerDiv isMobile={isMobile} />
      {CreateShopGroup(isMobile)}
    </div>
  );
};

export default ShopsDirectoryContent;
